import * as React from "react";
import { ConfigFieldDatePicker } from '../forms/informedv4/ConfigFieldDatePickerV4';
import { Form, useFormApi } from "informedv4";
import { ErrorBoundary } from "../././errors/ErrorBoundary";
import * as Moment from 'moment';
import { DatePickerAcceptDateRange } from '../forms/informedv4/DatePickerV4';
import { ConfigurableDataItemIds } from '../misc/api/ApiConfigurableDataItems';
import { TextBox } from "../forms/informedv4/TextBoxV4";
import { Checkbox } from "../forms/informedv4/CheckboxV4";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";

interface TerminationDateModalBodyProps {
    disabled: boolean;
    onSubmit: (values: EarlyTerminationForm) => void;
    onCloseModal: () => void;
    initialValues: EarlyTerminationForm;
}

export interface EarlyTerminationForm {
    SubjectNumber?: string;
    IsTerminated: boolean;
    TerminationDate: string;
}

export const TerminationDateModalBodyForm = ({ disabled, onSubmit, onCloseModal }: TerminationDateModalBodyProps) => {
    const formApi = useFormApi();
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();
    const [checked, setChecked] = React.useState(formApi.getFormState().values.IsTerminated);

    const handleSubmit = async () => {
        formApi.validate();
        const state = formApi.getFormState();

        if (state.invalid)
            return;

        onSubmit({ IsTerminated: true, TerminationDate: Moment(state.values.TerminationDate).format("YYYY-MM-DDTHH:mm:ssZ"), });
    }

    return (
        <ErrorBoundary>
            <div className="modal-body">
                {disabled ? null :
                    <>
                        <div className="form-group">
                            <label htmlFor="subjectNumber">{fieldDisplayText.SubjectId}</label>
                            <TextBox name="SubjectNumber" id="SubjectNumber" field="SubjectNumber" type="text" disabled />
                        </div>

                        <div className="form-group">
                            <Checkbox name="IsTerminated" label="Terminate from study" id="IsTerminated" field="IsTerminated" onChange={(c) => setChecked(c)} />
                        </div>
                        {checked ? <ConfigFieldDatePicker
                            name="TerminationDate"
                            id="TerminationDate"
                            field="TerminationDate"
                            className="form-group"
                            required={true}
                            includeTime={true}
                            acceptDateRange={DatePickerAcceptDateRange.PastOrPresent}
                            itemId={ConfigurableDataItemIds.TerminationDate}
                        /> : null}
                    </>
                }
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="button" data-automationid="TerminationDateModalSubmitButton"
                    onClick={handleSubmit}>
                    Submit
                </button>
                <button className="btn btn-primary btn-outline" data-automationid="TerminationDateModalCancelButton" onClick={() => onCloseModal()}>
                    Cancel
                </button>
            </div>
        </ErrorBoundary>
    );
}

export const TerminationDateModalBody = (props: TerminationDateModalBodyProps) => {
    return (
        <Form validateOn="submit" initialValues={props.initialValues as unknown as Record<string, unknown>}>
            <TerminationDateModalBodyForm  {...props} />
        </Form>
    );
}
